import React, { Component } from "react";
import messages from "./ProjectForm.messages";
import {
  Grid,
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Modal,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import "../forms.css";

import type { CreateProjectParamsObject } from "../../../redux/projects/types";
import type { DuplicateProjectParamsObject } from "../../../redux/projects/types";
import Project from "../../../models/Project";
import User from "../../../models/User";
import GradientButton from "../../../components/input/GradientButton";

type Props = {
  createProject: (params: CreateProjectParamsObject) => Promise<void>,
  onDidCreateProject: (projectId: string) => void,
  duplicateProject: (params: DuplicateProjectParamsObject) => Promise<void>,
  onDidDuplicateProject: (projectId: string) => void,
  onRequestBack: () => void,
  user: User,
  onModalClose: () => void,
  duplicate: boolean,
};

type State = {
  name: string,
  date: ?string,
  dateMoment: Object,
  collaboratorEmail: string,
  photoURI: string,
  timezone: string,
};

export default class ProjectForm extends Component {
  props: Props;

  state: State = {
    name: "",
    date: null,
    dateMoment: moment(),
    collaboratorEmail: "",
    photoURI: "",
    timezone: this.props.user.timezone ? this.props.user.timezone : "",
  };

  dateRef: DateField;
  collaboratorEmailRef: TextField;
  createProjectPromise: ?Promise<void>;
  duplicateProjectPromise: ?Promise<void>;

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {
    const formattedDate = moment(this.state.dateMoment._d).format("MM/DD/YYYY");
    this.setState({ date: formattedDate });
  }

  handleNameChange = (event) => {
    this.setState({ name: event.target.value });
  };

  handleDateChange(date) {
    if (date) {
      const formattedDate = moment(date._d).format("MM/DD/YYYY");
      this.setState({ date: formattedDate });
      this.setState({ dateMoment: date });
    }
  }

  handleTimezoneChange = (event) => {
    this.setState({ timezone: event.target.value });
  };

  handleCollaboratorChange = (event) => {
    this.setState({ collaboratorEmail: event.target.value });
  };

  handlePhotoChange = (event) => {
    this.setState({ photoURI: event.target.files[0] });
  };

  handleCreateProject = (event) => {
    event.preventDefault();
    this.createProjectPromise = Promise.resolve(this.createProject());
  };

  handleDuplicateProject = (event) => {
    event.preventDefault();
    this.duplicateProjectPromise = Promise.resolve(this.duplicateProject());
  };

  async createProject() {
    if (!this.state.date) {
      return;
    }
    const project = await this.props.createProject({
      name: this.state.name,
      date: this.state.date,
      photoURI: this.state.photoURI,
      collaboratorEmail: this.state.collaboratorEmail,
      timezone: this.state.timezone,
    });
    this.props.onDidCreateProject(
      project,
      this.state.name,
      this.state.date,
      this.state.timezone
    );
  }

  async duplicateProject() {
    if (!this.state.date) {
      return;
    }
    this.props.handleDuplicateProject({ date: this.state.date });
    this.props.onDidDuplicateProject();
  }

  render() {
    return (
      <div>
        <form
          onSubmit={
            this.props.duplicate
              ? this.handleDuplicateProject
              : this.handleCreateProject
          }
        >
          <Modal.Body>
            <Row>
              <Col sm={12}>
                {this.props.duplicate ? (
                  ""
                ) : (
                  <FormGroup>
                    <ControlLabel>{messages.name}</ControlLabel>
                    <FormControl
                      type="text"
                      name={messages.name}
                      placeholder={messages.name}
                      onChange={this.handleNameChange}
                    />
                  </FormGroup>
                )}
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <FormGroup>
                  <ControlLabel>{messages.date}</ControlLabel>
                  <DatePicker
                    className="form-control"
                    onChange={this.handleDateChange.bind(this)}
                    selected={this.state.dateMoment}
                    name={messages.date}
                    style={{ width: "100%" }}
                    placeholder={messages.date}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                {this.props.duplicate ? (
                  ""
                ) : (
                  <FormGroup>
                    <ControlLabel>{messages.collaboratorEmail}</ControlLabel>
                    <FormControl
                      type="text"
                      name={messages.collaboratorEmail}
                      placeholder={messages.collaboratorEmail}
                      onChange={this.handleCollaboratorChange}
                    />
                  </FormGroup>
                )}
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                {this.props.duplicate ? (
                  ""
                ) : (
                  <FormGroup>
                    <ControlLabel>{messages.photo}</ControlLabel>
                    <br />
                    <FormControl
                      type="file"
                      name={messages.photo}
                      placeholder={messages.photo}
                      onChange={this.handlePhotoChange}
                    ></FormControl>
                  </FormGroup>
                )}
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <GradientButton
              gradient="0/1"
              handleClick={this.props.onModalClose}
              title="Cancel"
            />
            <button type="submit" style={{ padding: 0, border: 'none' }}>
              <GradientButton
                gradient="1/1"
                handleClick={
                  this.props.duplicate
                    ? this.handleDuplicateProject
                    : this.handleAddProject
                }
                title={this.props.duplicate ? "Duplicate Event" : "Add Event"}
              />
            </button>
          </Modal.Footer>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/project-form/ProjectForm.js